import { useCallback } from "react";
import {
  getCCAFieldDefinitions,
  getExistingCodes,
} from "../../api/AnalysisCodes";
import { useWorkOrderStore } from "../../store/wo-order";
import { completeWO } from "../../api/CompletionData";
import { logCustomMessage } from "../../util/logger";
import { SeverityLevel } from "@microsoft/applicationinsights-web";
import { useIonAlert } from "@ionic/react";

export default function useCompleteWo() {
  const [presentAlert] = useIonAlert();

  const completeWo = useCallback(async (body: any) => {
    const response = await completeWO(body);
    logCustomMessage(
      "Complete Work Order in Complete screen",
      SeverityLevel.Information,
      "WorkOrders/CompleteWorkOrder",
      body,
      response
    );
    return response;
  }, []);

  const completeWorkOrder = useCallback(
    async (payload: any, woNumber: string) => {
      const workOrder = useWorkOrderStore.getState().getWorkOrderById(woNumber);
      const fields = await getCCAFieldDefinitions(workOrder?.Equipment);
      if (
        fields.componentField?.IsRequired ||
        fields.actionField?.IsRequired ||
        fields.conditionField?.IsRequired
      ) {
        const dateCreated = workOrder?.Events?.DateCreated;
        const timeCreated = workOrder?.Events?.TimeCreated;
        if (dateCreated && timeCreated) {
          const existingCodes = await getExistingCodes(
            dateCreated,
            timeCreated
          );
          if (existingCodes && existingCodes.length > 0) {
            return await completeWo(payload);
          } else {
            presentAlert(`CCA is Required`);
            return;
          }
        }
      } else {
        return await completeWo(payload);
      }
    },
    [completeWo, presentAlert]
  );

  return { completeWorkOrder };
}
